const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

// ========================
// Helper (common fetch handler)
// ========================
const handleResponse = async (res) => {
  let data = null;
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    let detail = `Request failed (${res.status})`;
    try { detail = JSON.parse(text)?.detail || detail; } catch {}
    throw new Error(detail);
  }
  try {
    data = await res.json();
  } catch (err) {
    console.error("Failed to parse JSON:", err);
  }
  return data;
};

// ========================
// Helper: Get Auth Headers
// ========================
const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

// ========================
// 📄 FILE UPLOAD
// ========================
export const uploadFile = async (file) => {
  try {
    const form = new FormData();
    form.append("file", file);
    const res = await fetch(`${BACKEND_URL}/api/submissions/upload`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: form,
    });
    return await handleResponse(res);
  } catch (err) {
    console.error("uploadFile error:", err);
    throw err;
  }
};

// ========================
// Journals
// ========================
export const getJournals = async () => {
  try {
    const res = await fetch(`${BACKEND_URL}/api/journals`);
    return await handleResponse(res);
  } catch (err) {
    console.error("getJournals error:", err);
    return [];
  }
};

export const getJournalById = async (id) => {
  try {
    const res = await fetch(`${BACKEND_URL}/api/journals/${id}`);
    return await handleResponse(res);
  } catch (err) {
    console.error("getJournalById error:", err);
    throw err;
  }
};

// ========================
// Submissions (Author)
// ========================
export const getSubmissions = async () => {
  try {
    const res = await fetch(`${BACKEND_URL}/api/submissions`, {
      headers: getAuthHeaders(),
    });
    return await handleResponse(res);
  } catch (err) {
    console.error("getSubmissions error:", err);
    return [];
  }
};

// ========================
// 🚀 FINAL SUBMIT (JSON ONLY)
// ========================
export const submitPaper = async (data) => {
  try {
    const res = await fetch(`${BACKEND_URL}/api/submissions/author`, {
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify(data),
    });
    return await handleResponse(res);
  } catch (err) {
    console.error("submitPaper error:", err);
    throw err;
  }
};

// ========================
// Journal Papers
// ========================
export const getJournalPapers = async (journalId) => {
  try {
    const res = await fetch(`${BACKEND_URL}/api/journals/${journalId}/papers`);
    return await handleResponse(res);
  } catch (err) {
    console.error("getJournalPapers error:", err);
    return [];
  }
};

// ========================
// Editorial Board
// ========================
export const getEditorialBoard = async (journalId) => {
  try {
    const res = await fetch(`${BACKEND_URL}/api/editorial-board/${journalId}`);
    return await handleResponse(res);
  } catch (err) {
    console.error("getEditorialBoard error:", err);
    return [];
  }
};

// ========================
// ADMIN / REVIEW FLOW
// ========================
export const getAllSubmissions = async () => {
  try {
    const res = await fetch(`${BACKEND_URL}/api/submissions`, {
      headers: getAuthHeaders(),
    });
    return await handleResponse(res);
  } catch (err) {
    console.error("getAllSubmissions error:", err);
    return [];
  }
};

export const updateSubmissionStatus = async (id, status) => {
  try {
    const res = await fetch(`${BACKEND_URL}/api/submissions/${id}/status`, {
      method: "PUT",
      headers: getAuthHeaders(),
      body: JSON.stringify({ status }),
    });
    return await handleResponse(res);
  } catch (err) {
    console.error("updateSubmissionStatus error:", err);
    throw err;
  }
};

export const publishToZenodo = async (submissionId) => {
  try {
    const res = await fetch(`${BACKEND_URL}/api/submissions/${submissionId}/publish`, {
      method: "POST",
      headers: getAuthHeaders(),
    });
    return await handleResponse(res);
  } catch (err) {
    console.error("publishToZenodo error:", err);
    throw err;
  }
};

// ========================
export const getReviews = async () => {
  return [];
};

// ========================
// Public Paper Detail
// ========================
export const getPublicPaper = async (id) => {
  try {
    const res = await fetch(`${BACKEND_URL}/api/papers/${id}`);
    return await handleResponse(res);
  } catch (err) {
    console.error("getPublicPaper error:", err);
    throw err;
  }
};
